import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "@/context/WishlistContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function WishlistButton({ productId, className = "", size = "md" }) {
  const { ids, toggle } = useWishlist();
  const { user } = useAuth();
  const navigate = useNavigate();
  const active = ids.has(productId);

  const sizes = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
  };
  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-[18px] h-[18px]",
    lg: "w-6 h-6",
  };

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.error("Please sign in to save to wishlist");
      navigate("/login");
      return;
    }
    const res = await toggle(productId);
    if (res.added) toast.success("Saved to wishlist ❤");
    else if (res.added === false) toast("Removed from wishlist");
  };

  return (
    <button
      onClick={onClick}
      type="button"
      className={`${sizes[size]} rounded-full bg-white/95 hover:bg-white shadow-md flex items-center justify-center transition-all hover:scale-110 ${className}`}
      data-testid={`wishlist-btn-${productId}`}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
    >
      <Heart
        className={`${iconSizes[size]} transition-colors ${active ? "fill-saffron text-saffron" : "text-foreground"}`}
      />
    </button>
  );
}
